import React from 'react';
import {
  Box,
  Typography,
  Paper,
  alpha,
  useTheme,
} from '@mui/material';
import CopyIconButton from '../../../shared/components/CopyIconButton';

interface TestResult {
  error?: string;
  detail?: string;
  result?: unknown;
}

interface RoleTestResultDisplayProps {
  testResult: TestResult;
}

const RoleTestResultDisplay: React.FC<RoleTestResultDisplayProps> = ({ testResult }) => {
  const theme = useTheme();
  return (
  <Paper
    variant="outlined"
    sx={{
      p: 2,
      bgcolor: testResult.error ? alpha(theme.palette.error.main, 0.1) : alpha(theme.palette.success.main, 0.1),
      borderColor: testResult.error ? 'error.main' : 'success.main'
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
        {testResult.error ? 'Test Failed' : 'Test Successful'}
      </Typography>
      <CopyIconButton
        text={JSON.stringify(testResult, null, 2)}
        tooltip="Copy to clipboard"
      />
    </Box>

    {testResult.error ? (
      <>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Error:</strong> {testResult.error}
        </Typography>
        {testResult.detail && (
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
            <strong>Details:</strong> {testResult.detail}
          </Typography>
        )}
      </>
    ) : (
      <>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Successfully assumed role in operations account
        </Typography>
        <Box sx={{ bgcolor: 'background.paper', p: 1, borderRadius: 1, mt: 1 }}>
          <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', display: 'block', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {JSON.stringify(testResult.result, null, 2)}
          </Typography>
        </Box>
      </>
    )}
  </Paper>
  );
};

export default RoleTestResultDisplay;
